module.exports = __webpack_public_path__ + "img/long-covid-definitions-image-left.cc09ab2a.png";